export interface PreOrderItem {
  id?: string;
  itemId: string;
  quantity: number;
}

export class PreOrder {
  items: PreOrderItem[] = [];
}
